"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActiveLocale = void 0;

var _get = _interopRequireDefault(require("transmute/get"));

var getActiveLocale = (0, _get.default)('activeLocale');
exports.getActiveLocale = getActiveLocale;